function parseState(state) {
  try {
    return JSON.parse(atob(decodeURIComponent(state)))
  } catch (err) {
    return { redirectUrl: state }
  }
}

function isCustomerConnection(deps) {
  return new RegExp("-Customers$").test(deps.options.connection)
}

function isAdfsConnection(deps) {
  return deps.options.connection.indexOf("-waad") !== -1 || deps.options.connection.indexOf("-okta") !== -1;
}

function getAuth(token, sessionId) {
  if (!sessionId) {
    if (!token) { return null; }

    return {
      type: "Bearer",
      token: token
    }
  } else {
    return {
      type: "Session",
      token: sessionId
    }
  }
}

module.exports = {
  parseState,
  isCustomerConnection,
  isAdfsConnection,
  getAuth
};